import requestManager from "@/utils/sanGaoStaff";

// 发送登录短信验证码（仅 product_mark=45 的内勤手机号）
export function sendSanGaoStaffCode(params) {
    return requestManager.request({
        url: "/sanGao/staff/sendCode",
        method: "post",
        data: params,
    });
}

// 普通内勤：手机号 + 验证码；泰康版：taikangMode=true + 手机号 + orgId。
export function loginSanGaoStaff(params) {
    return requestManager.request({
        url: "/sanGao/staff/login",
        method: "post",
        data: params,
    });
}

// 校验 token，返回当前登录内勤信息
export function getSanGaoStaffInfo() {
    return requestManager.request({
        url: "/sanGao/staff/info",
        method: "get",
    });
}

// 切换到当前手机号有内勤权限的机构；登录时可显式传入尚未落盘的 token。
export function switchSanGaoStaffOrg(orgId, token) {
    return requestManager.request({
        url: "/sanGao/staff/switchOrg",
        method: "post",
        data: { orgId },
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
}

// 机构业务员下拉列表
export function getSanGaoStaffSalesmanList() {
    return requestManager.request({
        url: "/sanGao/staff/salesmanList",
        method: "get",
    });
}

// 客户列表
// params: { auditStatus: 0-待审核 1-已通过 2-已驳回, salesmanId }
// 不传 auditStatus 返回本机构全部已提交问卷客户。旧端 auditStatus=1 仍含 1/3/4。
// 返回客户信息、最新有效问卷/初筛结果/报告评审及已保存体检记录，PC 端按真实状态细分展示。
export function getSanGaoStaffCustomerList(params) {
    return requestManager.request({
        url: "/sanGao/staff/customerList",
        method: "get",
        params,
    });
}

// 客户按状态计数
// params: { salesmanId }
export function getSanGaoStaffCustomerCount(params) {
    return requestManager.request({
        url: "/sanGao/staff/customerCount",
        method: "get",
        params,
    });
}

// 批量审核客户
// data: { customerIds: [..], auditStatus: 1-通过 2-驳回 }
export function auditSanGaoStaffCustomer(data) {
    return requestManager.request({
        url: "/sanGao/staff/audit",
        method: "post",
        data,
    });
}

// 删除本机构待审核客户的问卷记录（客户可重新填写）
export function deleteSanGaoStaffPendingQuestionnaire(customerId) {
    return requestManager.request({
        url: "/sanGao/staff/deletePendingQuestionnaire",
        method: "post",
        params: { customerId },
    });
}

// 客户详情（基本信息 + 问卷填写内容）
export function getSanGaoStaffCustomerDetail(params) {
    return requestManager.request({
        url: "/sanGao/staff/customerDetail",
        method: "get",
        params,
    });
}
